'use strict';

angular.module('app.advertiserProjectList')

.directive('advertiserProjectListDirective', function () {
        return {
            controller: 'advertiserProjectListCtrl',
            templateUrl: 'app/sideBarMenu/advertiserProjectList/advertiserProjectList.html?app_v=deployDate',
            scope: {}
        };
})